/**
 * Decorative hero-style background blobs — primary green on the left,
 * accent on the right, subtle primary on center. Mirrors the apps/web
 * homepage hero treatment but applied at app shell level so every page
 * (find, account, etc.) gets the same subtle teal gradient atmosphere.
 *
 * Fixed-positioned, pointer-events-none, behind everything. No layout
 * impact. Hidden on print.
 */
export function HeroBlob() {
  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden print:hidden"
    >
      {/* Primary blob — top-left (green, the dominant note) */}
      <div className="bg-primary/4 absolute -top-32 -left-24 h-[420px] w-[420px] rounded-full blur-3xl sm:h-[680px] sm:w-[680px]" />
      {/* Accent blob — bottom-right (indigo, subtler) */}
      <div className="bg-accent/[0.025] absolute -right-20 -bottom-24 h-[260px] w-[260px] rounded-full blur-3xl sm:h-[480px] sm:w-[480px]" />
      {/* Soft primary wash — upper center */}
      <div className="bg-primary/[0.02] absolute top-10 left-1/2 h-[180px] w-[180px] -translate-x-1/2 rounded-full blur-3xl sm:h-[340px] sm:w-[340px]" />
    </div>
  );
}
